import { render, staticRenderFns } from "./CvrUom.vue?vue&type=template&id=3572df4c&"
import script from "./CvrUom.vue?vue&type=script&lang=js&"
export * from "./CvrUom.vue?vue&type=script&lang=js&"
import style0 from "./CvrUom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CvrUom.vue"
export default component.exports